var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoT4AWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.3.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.641002247 -0.0335935043 0.0453249639 0.8648518314 346.9365671163 295.5808163924)",
    id: "k0SY7NAe_XIuyNYvUQEZG"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 67.52056 244.60972 C 179.94424 258.97806 344.6237 271.2455 205.35857 256.74043 C 66.09342999999998 242.23537 -144.92200000000003 196.30945 -202.72840000000002 138.83985 C -260.53479000000004 81.37025000000001 -178.99006000000003 -241.27459999999996 -220.96890000000002 -259.29377 C -262.94774 -277.31293999999997 -264.66875000000005 -231.95889 -251.26842000000002 -160.14944 C -240.29525 -101.34661 -262.48353000000003 109.93865000000002 -201.87437000000003 175.10324 C -172.00656000000004 207.21593000000001 -41.70849000000004 230.64965999999998 67.52055999999996 244.60971 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9781476007 -0.2079116908 0.3038662197 1.4295781663 323.2812430989 367.121403524)",
    id: "sN48XTmi5iRRGBrecCDJe"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 6.36969 -144.64925 C -42.45994 -130.18999 -18.839309999999998 121.22611 -14.09857 143.48085000000003 C -9.35783 165.73560000000003 -7.48226 15.238330000000019 0.6807999999999996 -28.133959999999973 C 8.84386 -71.50625999999997 45.20683 -156.14956999999998 6.369689999999999 -144.64924999999997 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4750866908 -0.0583333107 0.0888449962 0.7235844276 380.1967224567 315.7220930954)",
    id: "SzjbB_J-K028AuzLvcToi"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 0.20485 -145.68798 C -48.62478 -131.22872 5.91113 122.67967999999999 10.65187 144.93443 C 15.392610000000001 167.18918 -6.237779999999999 -0.9272600000000182 1.9252800000000008 -44.299560000000014 C 10.08834 -87.67186000000001 39.04199 -157.18830000000003 0.20485000000000086 -145.68798 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.4750866908 -0.0583333107 0.0750985806 0.6116288566 412.4460210899 319.6405495971)",
    id: "1fjKeJ8t3dYDpTPf6ztAA"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 0.20485 -145.68798 C -48.62478 -131.22872 5.91113 122.67967999999999 10.65187 144.93443 C 15.392610000000001 167.18918 -6.237779999999999 -0.9272600000000182 1.9252800000000008 -44.299560000000014 C 10.08834 -87.67186000000001 39.04199 -157.18830000000003 0.20485000000000086 -145.68798 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0116074096 -0.6649880516 1.6216570808 -0.0283061296 320 290.6133539783)",
    id: "01h2TBwLS_yWq8f842Vfx"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(0, 0)",
    d: "M 9.47081 -147.7188 C -46.54551 -134.58740999999998 -28.495089999999998 124.49671000000001 -23.754350000000002 146.75146 C -19.013610000000003 169.00621 -24.610110000000002 18.455460000000016 -16.447050000000004 -24.91683999999998 C -8.283990000000005 -68.28913999999997 65.48713 -160.85018999999997 9.470809999999997 -147.7188 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoT4AWhite);
export default __webpack_public_path__ + "static/media/logo_t4a_white.b0c70ee6f8d1517214dd0820918a20d0.svg";
export { ForwardRef as ReactComponent };